<template>
  <div>
      ERROR 404
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Error404.vue